/**
 * Waitlist Service
 * API calls for waitlist functionality
 */

import api from './api';

const waitlistService = {
  /**
   * Join the waitlist
   * @param {Object} data - Waitlist data
   * @param {string} data.name - User's name
   * @param {string} data.email - User's email
   * @param {string} data.role - User's role (trainer, ld, coach, teacher, other)
   * @returns {Promise} Response with success message
   */
  join: async (data) => {
    return api.post('/waitlist', data);
  },

  /**
   * Check if email is already on waitlist
   * @param {string} email - Email to check
   * @returns {Promise} Response with exists boolean
   */
  checkEmail: async (email) => {
    return api.get(`/waitlist/check/${encodeURIComponent(email)}`);
  },

  // Admin functions below

  /**
   * Get all waitlist entries (admin only)
   * @param {Object} params - Query parameters
   * @param {string} params.status - Filter by status
   * @param {string} params.role - Filter by role
   * @param {string} params.search - Search term
   * @param {number} params.page - Page number
   * @param {number} params.limit - Items per page
   * @returns {Promise} Paginated waitlist entries
   */
  getAll: async (params = {}) => {
    return api.get('/waitlist', params);
  },

  /**
   * Get waitlist statistics (admin only)
   * @returns {Promise} Waitlist stats
   */
  getStats: async () => {
    return api.get('/waitlist/stats');
  },

  /**
   * Update waitlist entry (admin only)
   * @param {string} id - Entry ID
   * @param {Object} data - Update data
   * @param {string} data.status - New status
   * @param {string} data.notes - Notes
   * @returns {Promise} Updated entry
   */
  update: async (id, data) => {
    return api.put(`/waitlist/${id}`, data);
  },

  /**
   * Delete waitlist entry (admin only)
   * @param {string} id - Entry ID
   * @returns {Promise} Success response
   */
  delete: async (id) => {
    return api.delete(`/waitlist/${id}`);
  },
};

export default waitlistService;
